import React, { createContext, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

const OnboardingContext = createContext(null);

export function OnboardingProvider({ children }) {
  const navigate = useNavigate();

  const openOnboarding = useCallback(() => {
    navigate('/welcome?replay=1');
  }, [navigate]);

  return (
    <OnboardingContext.Provider value={{ openOnboarding }}>
      {children}
    </OnboardingContext.Provider>
  );
}

export function useOnboarding() {
  const ctx = useContext(OnboardingContext);
  if (!ctx) {
    return {
      openOnboarding: () => {},
    };
  }
  return ctx;
}
